<div class="jb-max-width center">
  <ul class="jb-grid one-up grid-offset ma0 pl0 list">
    <li *ngFor="let flight of flightTrackerConnectingResults; let i = index">
      <button
        #connectingFlightButtons
        aria-haspopup="dialog"
        class="w-100 pa0 relative db dn-ns pointer"
        (click)="openMobileDialog(i, flight.legs[0], flight.legs[1])"
      >
        <div
          *ngFor="let leg of flight.legs; let j = index"
          class="flex flex-wrap mh0 pl0 tc center-l bg-white list"
        >
          <div class="w-100 db relative" [ngClass]="j === 0 ? 'pt3' : 'pb3'">
            <jb-flight-tracker-results-flightno-column
              [flightTrackerLeg]="leg"
            ></jb-flight-tracker-results-flightno-column>

            <jb-flight-tracker-results-departure-column
              [flightTrackerLeg]="leg"
            ></jb-flight-tracker-results-departure-column>

            <jb-flight-tracker-results-arrival-column
              [flightTrackerLeg]="leg"
            ></jb-flight-tracker-results-arrival-column>
          </div>

          <div *ngIf="j === 0" class="fl h2 w-100">
            <div class="fl five-percent-width pt3"></div>
            <div class="fl w-80 pt3 bb b--black-20"></div>
            <div class="fl w-10 pt2">
              <jb-icon
                class="fill-royal-blue"
                name="rightFilled"
                width="0.9em"
                height="0.9em"
              ></jb-icon>
            </div>
          </div>
        </div>
      </button>

      <div class="dn db-ns bb b--black-20">
        <div *ngFor="let leg of flight.legs; let j = index">
          <div class="flex flex-wrap mh0 pl0 tc center-l bg-white list">
            <div
              class="w-100 db relative"
              [ngClass]="j === 0 ? 'pt3 pv3-l' : 'pt2 pb3 pv3-ns'"
            >
              <span
                *ngIf="leg?.flightStatus | jbIncludesSubstring: 'CANCELLED'"
                [ngClass]="
                  j === 0
                    ? 'status-color-top-first-leg'
                    : 'status-color-top-second-leg'
                "
                class="fl bg-yellow dn db-ns absolute"
              ></span>
              <span
                *ngIf="leg?.flightStatus | jbIncludesSubstring: 'CANCELLED'"
                [ngClass]="
                  j === 0
                    ? 'status-color-bottom-first-leg'
                    : 'status-color-bottom-second-leg'
                "
                class="fl bg-yellow dn db-ns absolute"
              ></span>
              <jb-flight-tracker-results-flightno-column
                [flightTrackerLeg]="leg"
              ></jb-flight-tracker-results-flightno-column>
              <jb-flight-tracker-results-origin-column
                [flightTrackerLeg]="leg"
              ></jb-flight-tracker-results-origin-column>
              <jb-flight-tracker-results-departure-column
                [flightTrackerLeg]="leg"
              ></jb-flight-tracker-results-departure-column>
              <jb-flight-tracker-results-center-arrow-column></jb-flight-tracker-results-center-arrow-column>
              <jb-flight-tracker-results-arrival-column
                [flightTrackerLeg]="leg"
              ></jb-flight-tracker-results-arrival-column>
              <jb-flight-tracker-results-destination-column
                [flightTrackerLeg]="leg"
              ></jb-flight-tracker-results-destination-column>
              <jb-flight-tracker-results-status-column
                [flightTrackerLeg]="leg"
              ></jb-flight-tracker-results-status-column>
              <jb-flight-tracker-results-animation-message-section
                [flightTrackerLeg]="leg"
                (viewMapClicked)="openLargeDialog($event, leg)"
              ></jb-flight-tracker-results-animation-message-section>
              <div *ngIf="j === 0" class="fl w-100 dn-ns">
                <div class="fl five-percent-width pt3"></div>
                <div class="fl w-80 pt3 bb b--black-20"></div>
                <div class="fl w-10 pt2">
                  <jb-icon
                    class="fill-royal-blue"
                    name="rightFilled"
                    width="0.9em"
                    height="0.9em"
                  ></jb-icon>
                </div>
              </div>
            </div>

            <div class="w-100">
              <div class="ph3 dn db-ns">
                <jb-flight-tracker-results-inbound-plane
                  [flightTrackerLeg]="leg"
                />
              </div>

              <div
                *ngIf="j === 0"
                class="center w-90 bb b--black-20 dn db-ns"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
</div>
